module.exports = __webpack_public_path__ + "img/0Q3A7268_L_Foamcore_MockedUp.565da7a7.jpg";